module.exports = __webpack_public_path__ + "static/media/Graphic8.3e3d2a64.png";